'use es6';

import { fromJS } from 'immutable';
import { getCurrentStages } from 'reporting-enablement/components/reportEditors/PipelineStageOrderEditor/journeyStageUtils';
import JourneyPipelineStageEditor from 'reporting-enablement/components/reportEditors/PipelineStageOrderEditor/JourneyPipelineStageEditor';
import { isJourneyReport } from '../../utils/salesAnalyticsHelpers';
import { getOptionalStagesContextField, getStageContextField, getStageOptionValue } from '../../utils/stageHelpers';
import { useScopes } from '../../utils/use-scopes';
import { useGates } from '../../utils/use-gates';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const StageOrderControl = ({
  report,
  updateContext
}) => {
  const stagesContextField = getStageContextField(report);
  const optionalStagesContextField = getOptionalStagesContextField(report);
  const scopes = useScopes();
  const {
    gates
  } = useGates();
  return /*#__PURE__*/_jsx(JourneyPipelineStageEditor, {
    onChange: updatedReport => {
      const updatedStageData = getCurrentStages(updatedReport.toJS());
      const {
        selectedStages,
        optionalStages
      } = updatedStageData.reduce((memo, {
        pipelineObject,
        stageId,
        optional
      }) => {
        const stageKey = getStageOptionValue(pipelineObject, stageId);
        memo.selectedStages.push(stageKey);
        if (optional) {
          memo.optionalStages.push(stageKey);
        }
        return memo;
      }, {
        selectedStages: [],
        optionalStages: []
      });
      updateContext({
        [stagesContextField]: fromJS(selectedStages),
        [optionalStagesContextField]: fromJS(optionalStages)
      }, report);
    },
    report: report,
    userInfo: {
      scopes,
      gates
    }
  });
};
const INCOMPATIBLE_SUB_APPS = [SUB_APPS.customerJourneyAnalytics];
StageOrderControl.isUsableForReport = ({
  report,
  subAppKey
}) => {
  return isJourneyReport(report) && !INCOMPATIBLE_SUB_APPS.includes(subAppKey);
};
export default StageOrderControl;